import { useCallback } from "react";

import { useGlobalContext } from "context/GlobalContext";

import { formatCurrency } from "utils/currency";

export const useFormatCurrency = (initOptions = {}) => {
  const {
    loadingText = "...",
    currencyCode,
  } = initOptions;

  const { store, isRefetchingStore } = useGlobalContext();

  const customFormatCurrency = useCallback((value, options = {}) => {
    if (isRefetchingStore || !store) {
      return loadingText;
    }

    const newOptions = {
      currency: currencyCode || store.currency_code,
      ...options,
    };

    return formatCurrency(value, newOptions);
  }, [store, isRefetchingStore, loadingText, currencyCode]);

  return customFormatCurrency;
}
